import React from 'react';

import './styles.css';

export default function StudentNotificationsCardItem(props) {
    return(
        <li className='student-card-notifications-list-item'>
            <div>
                <p className='tittle'><b>{props.tittle}</b></p>
                <p className='content'>{props.content}</p>
            </div>
            <span className='date'>{props.date}</span>
        </li>
    )
}